import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule, LazyloadService } from '@dm/core';

import { TaskModuleEmbed } from '../task/task.module';
import { TaskSComponent } from './task-s.component';

@NgModule({
    declarations: [
        TaskSComponent,
    ],
    exports: [
        TaskSComponent,
    ],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
        TaskModuleEmbed,
    ],
    providers: [
        LazyloadService,
    ],
})
export class TaskSModule { }
